export default function RcmpRightArrowAccordion(props) {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill={props.fill || "#415364"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.65632 1.047L6.19905 5.78771C6.3094 5.9019 6.36419 6.05005 6.36419 6.19744C6.36419 6.34482 6.3094 6.49294 6.19905 6.60714L1.65632 11.3478C1.43034 11.5847 1.05533 11.5925 0.819231 11.3656C0.581576 11.1403 0.573848 10.7637 0.801478 10.5284L4.9508 6.19744L0.801478 1.86644C0.573848 1.63187 0.581576 1.25456 0.819231 1.02925C1.05533 0.802407 1.43034 0.810111 1.65632 1.047Z"
      />
    </svg>
  )
}
